import { render, staticRenderFns } from "./SettingPosition.vue?vue&type=template&id=048159a0&scoped=true&"
import script from "./SettingPosition.vue?vue&type=script&lang=js&"
export * from "./SettingPosition.vue?vue&type=script&lang=js&"
import style0 from "./SettingPosition.vue?vue&type=style&index=0&id=048159a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048159a0",
  null
  
)

export default component.exports